import React from 'react';

import {t} from 'i18next';

import {Coin} from 'assets/icons/icon';
import {PROMOTION_SUGGESTION_TARGET_UNIT} from 'constants/recommendation';
import {formatPriceWithoutDecimal} from 'utils';

import {LeoPromotionRibbon, LeoPromotionRibbonCount, LeoPromotionRibbonLabel} from './styles';
import {ProPointPromotionBoxProps} from './types';

const ProPointPromotionBox: React.FC<ProPointPromotionBoxProps> = ({promotionSuggestion, totalPromotions}) => {
  const promotionTextKey =
    promotionSuggestion.targetType === PROMOTION_SUGGESTION_TARGET_UNIT
      ? t('labels.proPointSuggestionUnits')
      : t('labels.proPointSuggestion');

  const promotionText = t(promotionTextKey, {
    targetValue: formatPriceWithoutDecimal(promotionSuggestion.targetValue),
    rewardValue: promotionSuggestion.rewardValue
  });

  if (totalPromotions === 0 || (promotionSuggestion.targetValue === 0 && promotionSuggestion.rewardValue === 0)) {
    return null;
  }

  return (
    <LeoPromotionRibbon>
      <LeoPromotionRibbonLabel>
        <Coin width={16} height={16} />
        <span>{promotionText}</span>
      </LeoPromotionRibbonLabel>
      {totalPromotions > 1 ? <LeoPromotionRibbonCount>+{totalPromotions - 1}</LeoPromotionRibbonCount> : null}
    </LeoPromotionRibbon>
  );
};

export default React.memo(ProPointPromotionBox);
